<app-header *ngIf="!router.url.includes('certificate-login') && !router.url.includes('student-login')"></app-header>
<router-outlet *ngIf="router.url.includes('certificate-login') || router.url.includes('student-login')"></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#1354f4" type="line-spin-fade-rotating"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner><ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade-rotating"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
<!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-spin" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
<!-- *ngIf="!router.url.includes('student-login')  && !router.url.includes('student-registration')" -->
<!-- *ngIf="router.url.includes('student-login') || router.url.includes('student-registration')" -->